export const motivosRetiro = [
    { label: 'TERMINACIÓN DE CONTRARO', value: '1' },
    { label: 'RENUNCIA VOLUNTARIA ', value: '2' },
    { label: 'TERMINACIÓN DE CONTRATO CON JUSTA CAUSA', value: '3' },
    { label: 'TERMINACIÓN DE CONTRATO SIN JUSTA CAUSA', value: '4' },
    { label: 'RETIRO NO NEGATIVO', value: '21' },
    { label: 'OTRO', value: '5' },
]